import { render, staticRenderFns } from "./AdminRestrictedModal.vue?vue&type=template&id=36ed5456&"
import script from "./AdminRestrictedModal.vue?vue&type=script&lang=js&"
export * from "./AdminRestrictedModal.vue?vue&type=script&lang=js&"
import style0 from "./AdminRestrictedModal.vue?vue&type=style&index=0&id=36ed5456&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports